import styled from 'styled-components';

import Warning from 'assets/icons/status/warning-16.svg';

import BlankButton from 'basics/buttons/BlankButton';

import { respondDown } from 'styles/mixins';
import { Breakpoints, COLORS } from 'styles/style-constants';

export const Container = styled.section`
    position: relative;
    margin: 0 auto;
    max-width: 142rem;
    padding: 1rem 10rem 0;
    width: 100%;

    ${respondDown(Breakpoints.md)`
        padding: 0 1.6rem;
        max-width: 55rem;
    `}
`;

export const Header = styled.div`
    display: flex;
    align-items: center;
    justify-content: space-between;
    margin-bottom: 4.2rem;

    ${respondDown(Breakpoints.md)`
        flex-direction: column;
        margin-top: 4rem;
    `}
`;

export const Title = styled.h3`
    font-size: 3.5rem;
    line-height: 4.1rem;
    color: ${COLORS.textPrimary};
    font-weight: normal;

    ${respondDown(Breakpoints.md)`
        margin-bottom: 2rem;
        font-size: 2.5rem;
    `}
`;

export const LastUpdated = styled.div`
    display: flex;
    align-items: center;
    font-size: 1.4rem;
    line-height: 2rem;
    color: ${COLORS.textGray};
    min-height: 2rem;

    & > span {
        display: flex;
        align-items: center;
        margin-right: 1rem;
    }

    svg {
        cursor: help;
    }
`;

export const Retry = styled(BlankButton)`
    color: ${COLORS.purple500};
    font: inherit;
    text-decoration: underline;
`;

export const LoadingMarket = styled.div`
    display: flex;
    align-items: center;
    gap: 1.6rem;

    ${respondDown(Breakpoints.md)`
        flex-direction: column;
        align-items: flex-start;
        gap: 0;
    `}
`;

export const LoadingPair = styled.div`
    display: flex;
    align-items: center;
    justify-content: center;
    width: 12rem;
    height: 3.8rem;
    ${respondDown(Breakpoints.md)`justify-content: flex-start;`}

    & > :last-child {
        margin-left: -1.2rem;
    }
`;

export const TooltipInner = styled.div`
    width: 20rem;
    white-space: pre-wrap;

    div {
        font-size: 1.4rem;
    }
`;

export const WarningIcon = styled(Warning)`
    margin: 0 0.5rem;
`;

export const Amount = styled.div`
    display: flex;
    align-items: center;
    font-size: 1.4rem;
    line-height: 2rem;
    color: ${COLORS.textGray};

    a {
        display: flex;
        align-items: center;
    }
`;

export const LoadingMarketText = styled.div`
    display: flex;
    flex-direction: column;
    justify-content: center;
    gap: 0.8rem;
    min-height: 4.8rem;
    ${respondDown(Breakpoints.md)`min-height: 5.9rem;`}
`;
